var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips-content"},[(_vm.flag)?_c('Tooltip',{staticStyle:{"width":"100%"},attrs:{"content":_vm.txtInfo,"placement":"top","theme":"dark","disabled":_vm.isDisabled}},[_c('div',{staticClass:"wordnowrap",on:{"mouseenter":_vm.isShowTooltip}},[_vm._v(_vm._s(_vm.txtInfo))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }